import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodas(filtro) {
        return axiosJwt
            .get(
                `${api}/contratos/requisicoes?processo=${filtro.processo ? filtro.processo : ''
                }&contrato=${filtro.contrato ? filtro.contrato : ''
                }&processoCliente=${filtro.processoCliente ? filtro.processoCliente : '' 
                }&fornecedor=${filtro.fornecedor ? filtro.fornecedor : ''
                }&solicitante=${filtro.solicitante ? filtro.solicitante : ''
                }&dataRequisicaoDe=${filtro.dataRequisicaoDe ? filtro.dataRequisicaoDe : ''
                }&dataRequisicaoAte=${filtro.dataRequisicaoAte ? filtro.dataRequisicaoAte : ''
                }&situacao=${filtro.situacao ? filtro.situacao : ''}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterOpcoesFiltros() {
        return axiosJwt
            .get(`${api}/contratos/requisicoes/opcoesfiltros`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorId(idRequisicao) {
        return axiosJwt
            .get(`${api}/contratos/requisicoes/${idRequisicao}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimento(idRequisicao, idComprometimento) {
        return axiosJwt
            .get(
                `${api}/contratos/requisicoes/${idRequisicao}/comprometimentos/${idComprometimento}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterContratos() {
        return axiosJwt
            .get(`${api}/contratos/requisicoes/contratosvigentes`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterContrato(idContrato) {
        return axiosJwt
            .get(`${api}/contratos/requisicoes/contratosvigentes/${idContrato}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterProcesso(numProcesso, operacao) {
        return axiosJwt
            .get(
                `${api}/contratos/requisicoes/processos?processo=${numProcesso}&operacao=${operacao}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterSolicitantes() {
        return axiosJwt
            .get(`${api}/contratos/requisicoes/solicitantes`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirRequisicao(requisicao) {
        return axiosJwt
            .post(`${api}/contratos/requisicoes/inserir`, requisicao)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarRequisicao(requisicao) {
        return axiosJwt
            .post(`${api}/contratos/requisicoes/atualizar`, requisicao)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterItensDisponiveis(idRequisicao) {
        return axiosJwt
            .get(
                `${api}/contratos/requisicoes/${idRequisicao}/itenscontratodisponiveis`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirItensRequisicao(itensRequisicao) {
        return axiosJwt
            .post(
                `${api}/contratos/requisicoes/${itensRequisicao.idRequisicao}/inseriritens`,
                itensRequisicao
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarItemRequisicao(itemRequisicao) {
        return axiosJwt
            .post(
                `${api}/contratos/requisicoes/${itemRequisicao.idRequisicao}/atualizaritem`,
                itemRequisicao
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirItemRequisicao(itensRequisicao) {
        return axiosJwt
            .post(
                `${api}/contratos/requisicoes/${itensRequisicao.idRequisicao}/excluiritem`,
                itensRequisicao
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarDescontoItemRequisicao(itemRequisicao) {
        return axiosJwt
            .post(
                `${api}/contratos/requisicoes/${itemRequisicao.idRequisicao}/atualizardescontoitem`,
                itemRequisicao
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterItensRequisicaoDisponiveis(idRequisicao) {
        return axiosJwt
            .get(
                `${api}/contratos/requisicoes/${idRequisicao}/itensrequisicaodisponiveis`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirRateioRequisicao(rateioRequisicao) {
        return axiosJwt
            .post(
                `${api}/contratos/requisicoes/${rateioRequisicao.idRequisicao}/inserirrateio`,
                rateioRequisicao
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarRateioRequisicao(rateioRequisicao) {
        return axiosJwt
            .post(
                `${api}/contratos/requisicoes/${rateioRequisicao.idRequisicao}/atualizarrateio`,
                rateioRequisicao
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirRateioRequisicao(rateioRequisicao) {
        return axiosJwt
            .post(
                `${api}/contratos/requisicoes/${rateioRequisicao.idRequisicao}/excluirrateio`,
                rateioRequisicao
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    comprometer(comprometimento) {
        return axiosJwt
            .post(
                `${api}/contratos/requisicoes/${comprometimento.idRequisicao}/comprometer`,
                comprometimento
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    descomprometer(comprometimento) {
        return axiosJwt
            .post(
                `${api}/contratos/requisicoes/${comprometimento.idRequisicao}/descomprometer`,
                comprometimento
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    copiar(comprometimento) {
        return axiosJwt
            .post(
                `${api}/contratos/requisicoes/${comprometimento.idRequisicao}/copiar`,
                comprometimento
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    finalizar(requisicao) {
        return axiosJwt
            .post(
                `${api}/contratos/requisicoes/${requisicao.idRequisicao}/finalizar`,
                requisicao
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDadosCancelamento(idRequisicao) {
        return axiosJwt
            .get(
                `${api}/contratos/requisicoes/${idRequisicao}/dadoscancelamento`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    cancelar(cancelamento) {
        return axiosJwt
            .post(
                `${api}/contratos/requisicoes/${cancelamento.idRequisicao}/cancelar`,
                cancelamento
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDadosDevolucao(idRequisicao) {
        return axiosJwt
            .get(`${api}/contratos/requisicoes/${idRequisicao}/dadosdevolucao`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    devolver(devolucao) {
        return axiosJwt
            .post(
                `${api}/contratos/requisicoes/${devolucao.idRequisicao}/devolver`,
                devolucao
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDadosEnvio(idRequisicao) {
        return axiosJwt
            .get(`${api}/contratos/requisicoes/${idRequisicao}/dadosenvio`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    enviar(envio) {
        const formData = new FormData()
        formData.append('idRequisicao', envio.idRequisicao)
        formData.append('destinatarios', envio.destinatarios)
        formData.append('titulo', envio.titulo)
        formData.append('mensagem', envio.mensagem)
        for (var x = 0; x < envio.anexos.length; x++) {
            formData.append("anexos", envio.anexos[x]);
        }

        return axiosJwt
            .post(
                `${api}/contratos/requisicoes/${envio.idRequisicao}/enviar`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    verificarSaldoNatureza(comprometimentos) {
        return axiosJwt
            .post(
                `${api}/contratos/requisicoes/verificarsaldonatureza`,
                comprometimentos
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    comprometerSelecionados(comprometimentos) {
        return axiosJwt
            .post(
                `${api}/contratos/requisicoes/${comprometimentos.idRequisicao}/comprometerselecionados`,
                comprometimentos
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDotacoesProcesso(idRequisicao) {
        return axiosJwt
            .get(
                `${api}/contratos/requisicoes/${idRequisicao}/dotacoes`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDotacoesContrato(idRequisicao) {
        return axiosJwt
            .get(
                `${api}/contratos/requisicoes/${idRequisicao}/dotacoescontrato`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDestinatarios(idRequisicao) {
    return axiosJwt
        .get(
            `${api}/contratos/requisicoes/${idRequisicao}/destinatarios`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    
    obterFaseDemandaAtual(idContrato) {
        return axiosJwt
            .get(
                `${api}/contratos/requisicoes/fasedemandaatual/${idContrato}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    gerarCodigoProcesso() {
        return axiosJwt
            .get(
                `${api}/contratos/requisicoes/gerar-codigo-processo`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    sugerirNumeroProcesso(idContrato) {
        return axiosJwt
            .get(
                `${api}/contratos/requisicoes/sugerir-numero-processo?idContrato=${idContrato}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
}
